import {gql} from '@apollo/client';

import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {BenchlingQueryResult, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {AllResultSchemasQuery} from './__generated/AllResultSchemasQuery';

export const ALL_RESULT_SCHEMAS_QUERY = gql`
  query AllResultSchemasQuery @skipAudit @engComponent(name: LAB_AUTOMATION) {
    ...AllResultSchemasGraphQL
  }
  ${getFragmentWrapper('AllResultSchemas').fragment}
`;

export function useAllResultSchemasQuery(): BenchlingQueryResult<AllResultSchemasQuery> {
  return useBenchlingQuery<AllResultSchemasQuery>(ALL_RESULT_SCHEMAS_QUERY);
}

export function doAllResultSchemasQuery(): Promise<AllResultSchemasQuery> {
  return doQuerySafe<AllResultSchemasQuery, {}>({query: ALL_RESULT_SCHEMAS_QUERY});
}
